import { Typography } from '@healthinal/ui';
import type { IPersonDetails } from '../../../../api/generated/person-controller/person-controller.ts';

export function EditPersonFormHeader({ person }: { person: IPersonDetails }) {
  return (
    <Typography level="h4">
      {person.lastName?.toUpperCase()} {person.firstName}
    </Typography>
  );
}
